/* 
 * @desc 获取url参数
 * @param {String} name  想要获取的参数名字
 */
export const getQuery = (name) => {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}
/* 
 * @desc 数组去重
 * @param {String} arr  想要去重的数组
 */
export const unique1 = (arr) => {
  let newArr = [];
  let obj = {};
  for (var i = 0; i < arr.length; i++) {
    arr[i].checked = false
    if (!obj[arr[i].TaskId]) {
      arr[i].checked = false
      newArr.push(arr[i])
      obj[arr[i].TaskId] = true
    }
  }
  return newArr
}
/* 
 * @desc 数组去重
 * @param {String} arr  想要去重的数组
 */
export const isMobile = () => {
  (function () {
    var f = /iPhone/i,
      j = /iPod/i,
      p = /iPad/i,
      g = /\bAndroid(?:.+)Mobile\b/i,
      i = /Android/i,
      d = /\bAndroid(?:.+)SD4930UR\b/i,
      e = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,
      c = /Windows Phone/i,
      h = /\bWindows(?:.+)ARM\b/i,
      k = /BlackBerry/i,
      l = /BB10/i,
      m = /Opera Mini/i,
      n = /\b(CriOS|Chrome)(?:.+)Mobile/i,
      o = /Mobile(?:.+)Firefox\b/i;

    function b($, a) {
      return $.test(a)
    }

    function a($) {
      var a = ($ = $ || ("undefined" != typeof navigator ? navigator.userAgent : "")).split("[FBAN");
      void 0 !== a[1] && ($ = a[0]), void 0 !== (a = $.split("Twitter"))[1] && ($ = a[0]);
      var r = {
        apple: {
          phone: b(f, $) && !b(c, $),
          ipod: b(j, $),
          tablet: !b(f, $) && b(p, $) && !b(c, $),
          device: (b(f, $) || b(j, $) || b(p, $)) && !b(c, $)
        },
        amazon: {
          phone: b(d, $),
          tablet: !b(d, $) && b(e, $),
          device: b(d, $) || b(e, $)
        },
        android: {
          phone: !b(c, $) && b(d, $) || !b(c, $) && b(g, $),
          tablet: !b(c, $) && !b(d, $) && !b(g, $) && (b(e, $) || b(i, $)),
          device: !b(c, $) && (b(d, $) || b(e, $) || b(g, $) || b(i, $)) || b(/\bokhttp\b/i, $)
        },
        windows: {
          phone: b(c, $),
          tablet: b(h, $),
          device: b(c, $) || b(h, $)
        },
        other: {
          blackberry: b(k, $),
          blackberry10: b(l, $),
          opera: b(m, $),
          firefox: b(o, $),
          chrome: b(n, $),
          device: b(k, $) || b(l, $) || b(m, $) || b(o, $) || b(n, $)
        },
        any: !1,
        phone: !1,
        tablet: !1
      };
      return r.any = r.apple.device || r.android.device || r.windows.device || r.other.device, r.phone = r.apple.phone || r.android.phone || r.windows.phone, r.tablet = r.apple.tablet || r.android.tablet || r.windows.tablet, r
    }
    window.isMobile = a();
  })();
  return window.isMobile.any
}

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1);
  const keysArr2 = Object.keys(obj2);
  if (keysArr1.length !== keysArr2.length) return false;
  else if (keysArr1.length === 0 && keysArr2.length === 0) return true;
  /* eslint-disable-next-line */
  else return !keysArr1.some(key => obj1[key] != obj2[key])
};


/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 一个对象是另一个对象的一部分，判断这个小对象和大对象是否相等,返回不同的部分
 */
export const objSectionEqual = (obj1, obj2) => {
  let obj = {};
  for (let key in obj1) {
    if (obj1[key] !== obj2[key]) {
      obj[key] = obj1[key];
    }
  }
  let boolean = Boolean(Object.keys(obj).length);
  return [obj, boolean];
}

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
  const ua = window.navigator.userAgent
  const isExplorer = (exp) => {
    return ua.indexOf(exp) > -1
  }
  if (isExplorer('MSIE')) {
    return ua.match(/msie\s\d+/)[0].match(/\d+/)[0] || ua.match(/trident\s?\d+/)[0];
  } else if (isExplorer('Firefox')) return 'Firefox'
  else if (isExplorer('Chrome')) return 'Chrome'
  else if (isExplorer('Opera')) return 'Opera'
  else if (isExplorer('Safari')) return 'Safari'
}
/**
 * 判断是否为空
 */
export function validatenull(val) {
  if (typeof val == 'boolean') {
    return false;
  }
  if (typeof val == 'number') {
    return false;
  }
  if (val instanceof Array) {
    if (val.length == 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true;
  } else {
    if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true;
    return false;
  }
  return false;
}
/**
 * 存储localStorage
 */
export const setStore = (params = {}) => {
  let {
    name,
    content,
    type,
  } = params;
  name = 'jiajukrpano_' + name
  let obj = {
    dataType: typeof (content),
    content: content,
    type: type,
    datetime: new Date().getTime()
  }
  if (type) window.sessionStorage.setItem(name, JSON.stringify(obj));
  else window.localStorage.setItem(name, JSON.stringify(obj));
}
/**
 * 获取localStorage
 */
export const getStore = (params = {}) => {
  let {
    name,
    debug
  } = params;
  name = 'jiajukrpano_' + name
  let obj = {},
    content;
  obj = window.sessionStorage.getItem(name);
  if (validatenull(obj)) obj = window.localStorage.getItem(name);
  if (validatenull(obj)) return;
  try {
    obj = JSON.parse(obj);
  } catch (err) {
    return obj;
  }
  if (debug) {
    return obj;
  }
  if (obj.dataType == 'string') {
    content = obj.content;
  } else if (obj.dataType == 'number') {
    content = Number(obj.content);
  } else if (obj.dataType == 'boolean') {
    content = eval(obj.content);
  } else if (obj.dataType == 'object') {
    content = obj.content;
  }
  return content;
}
export const getObjType = obj => {
  var toString = Object.prototype.toString;
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
};

/**
 * 对象深拷贝
 */
export const deepClone = data => {
  var type = getObjType(data);
  var obj;
  if (type === 'array') {
    obj = [];
  } else if (type === 'object') {
    obj = {};
  } else {
    //不再具有下一层次
    return data;
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
};

//替换指定传入参数的值,url为地址,paramName为参数,replaceWith为新值
export const replaceParamVal = (url, paramName, replaceVal) => {
  var oUrl = url.toString();
  var re = eval('/(' + paramName + '=)([^&]*)/gi');
  var nUrl = oUrl.replace(re, paramName + '=' + replaceVal);
  return nUrl;
}

//Emoji编码：
export const emojiEncode = (e) => {
  var n = /[\ud800-\udbff][\udc00-\udfff]/g;
  // 检测utf16字符正则长度,长度为2的无法存到数据库
  return e = e.replace(n, function(e) {
    return 2 === e.length ? '' : e
  })
}
// 判断字符串是否包含表情符
export const hasEmoji = (value) => {
	return /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig.test(value);
}


// WEBPACK FOOTER //
// ./src/utils/index.js